import { FormFieldDefinition } from '../../../../../../generic/universal-table/types/form.types'
import { CustomerUiRow } from '../types/customerTable.types'

export const customerTableFormFields: FormFieldDefinition<CustomerUiRow>[] = [
  {
    name: 'CustomerName',
    label: 'שם לקוח',
    inputType: 'text',
    required: true,
    placeholder: 'הזן שם לקוח',
    validationRules: {
      required: true,
      minLength: 1,
      maxLength: 100,
    },
  },
  {
    // getOptions is injected in CustomerTableModule.tsx
    name: 'ClientID',
    label: 'לקוח',
    inputType: 'searchable-select',
    required: false,
  },
  {
    // getOptions is injected in CustomerTableModule.tsx
    name: 'ResellerID',
    label: 'משווק',
    inputType: 'searchable-select',
    required: false,
  },
  {
    // getOptions is injected in CustomerTableModule.tsx
    name: 'MarketingAreaID',
    label: 'אזור שיווק',
    inputType: 'searchable-select',
    required: false,
  },
  {
    name: 'CustomerType',
    label: 'סוג לקוח',
    inputType: 'text',
    required: false,
    placeholder: 'סוג לקוח',
    validationRules: {
      maxLength: 50,
    },
  },
  {
    name: 'Phone',
    label: 'טלפון',
    inputType: 'text',
    required: false,
    placeholder: 'טלפון',
    validationRules: {
      maxLength: 50,
    },
  },
  {
    name: 'ShippAddress',
    label: 'כתובת משלוח',
    inputType: 'text',
    required: false,
    placeholder: 'כתובת משלוח',
    validationRules: {
      maxLength: 255,
    },
  },
  {
    name: 'Color',
    label: 'צבע',
    inputType: 'text',
    required: false,
    placeholder: 'צבע',
    validationRules: {
      maxLength: 50,
    },
  },
  {
    name: 'Company',
    label: 'חברה',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Cosher',
    label: 'כשרות',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'CustomerGroupID',
    label: 'קבוצת לקוח',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'DeliveryCode',
    label: 'קוד משלוח',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'LandTransp',
    label: 'הובלה יבשתית',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Meher',
    label: 'מהדרין',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'NeedGrowthGroup',
    label: 'קבוצת גידול',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'OneMany',
    label: 'יחיד/רבים',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'PickupGroup',
    label: 'קבוצת איסוף',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'PickupWarehouse',
    label: 'מחסן איסוף',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'PriceListID',
    label: 'מזהה מחירון',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'RampId',
    label: 'רמפה',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'TransferPallets2Warehouse',
    label: 'העברת משטחים למחסן',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'TrasportationMethod',
    label: 'שיטת הובלה',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'WarehouseID',
    label: 'מחסן',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'has_levies',
    label: 'היטלים',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Active',
    label: 'פעיל',
    inputType: 'boolean-select',
    required: false,
    defaultValue: true,
  },
  {
    name: 'AllowBouncing',
    label: 'מאפשר קפיצה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Blocked',
    label: 'חסום',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'DeliveryPrice',
    label: 'מחיר משלוח',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Friday',
    label: 'שישי',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Monday',
    label: 'שני',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'PackUsage',
    label: 'שימוש באריזה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'PriceList',
    label: 'מחירון פעיל',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Saturday',
    label: 'שבת',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'SavedPriceToOrderProduct',
    label: 'שמירת מחיר להזמנה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'TransferResetCustomerID',
    label: 'איפוס לקוח בהעברה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Tuesday',
    label: 'שלישי',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Wednesday',
    label: 'רביעי',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
]
